<div class="top">
  <h4 class="page-title ">APPLICATION DETAILS</h4>

  <span class="material-symbols-outlined text-danger" (click)="back()" role="button">close</span>
</div>

<div class="form-wrapper">
  <form [formGroup]="form">

    <div class="form-section">
      <h5 class="form-section-heading mb-3">OWNERS INFORMATION:</h5>
      <div class="body">
        <div class=" row g-3">
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" placeholder="Enter first name" class="form-control mt-0" formControlName="firstName"
                maxlength="60" />
              <app-error-message [form]="form" controlName="firstName"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" placeholder="Enter middle name" class="form-control mt-0" formControlName="middleName"
                maxlength="60" />
              <app-error-message [form]="form" controlName="middleName"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">LAST NAME</label>
              <input type="text" placeholder="Enter last name" class="form-control mt-0" formControlName="lastName"
                maxlength="60" />
              <app-error-message [form]="form" controlName="lastName"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">PHONE NUMBER</label>
              <input type="text" placeholder="e.g. 09087763552" class="form-control mt-0" formControlName="phoneNumber"
                maxlength="17" />
              <app-error-message [form]="form" controlName="phoneNumber"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>

          <div class="col-12 ">
            <div class="field">
              <label class="mb-0 required">ADDRESS</label>
              <input type="text" placeholder="Enter Address" class="form-control mt-0" formControlName="address"
                maxlength="200" />
              <app-error-message [form]="form" controlName="address"
                [showErrorMessage]="showErrorMessages"></app-error-message>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="form-section">
      <h5 class="form-section-heading mb-3">STREET INFORMATION:</h5>
      <div class=" row g-3">


        <div class="col-sm-6 col-md-4">
          <div class="field">
            <label class="mb-0 required">STREET TYPE</label>
            <!-- <ng-select [items]="streetTypes" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                placeholder="-- Select Option--" formControlName="streetType" 
                  class="ng-select control"> </ng-select> -->

            <input type="text" formControlName="streetType" class="form-control mt-0">
            <app-error-message [form]="form" controlName="streetType"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>


        <div class="col-sm-6 col-md-4">
          <div class="field">
            <label class="mb-0 required">PROPOSED STREET NAME</label>

            <input type="text" placeholder="Enter street name" class="form-control mt-0" formControlName="streetName"
              maxlength="100" />

            <app-error-message [form]="form" controlName="streetName"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>


        <div class="col-sm-6 col-md-4">
          <div class="field">
            <label class="mb-0 required">Necessary documents</label>
            
            <app-upload-input [accept]="'.png, .jpg, .jpeg, .pdf'" [maxFileSize]="1" [isInPreviewMode]="true"
              (fileChange)="onFileChange($event, 'documentUpload')" (error)="onError($event, 'documentUpload')"
              [form]="form" controlName="documentUpload" ></app-upload-input>

              

            <app-error-message [form]="form" [maxFileSize]="1" controlName="documentUpload" label="Image upload"
              [showErrorMessage]="showErrorMessages"></app-error-message>
          </div>
        </div>
      </div>
    </div>


  </form>


  <div class="modal-actions-wrapper mt-3"
    *ngIf="hasAccess(['CAN_APPROVE_LGA_IDENTIFICATION', 'CAN_QUERY_LGA_IDENTIFICATION']) && dialogData?.approvalStatus == 'PENDING' ">
    <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
      <span>DECLINE</span>
      <span class="spinner-light" *ngIf="isQueryingApplication"></span>
    </button>

    <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
      <span>APPROVE</span>
      <span class="spinner-light" *ngIf="isApprovingApplication"></span>
    </button>
  </div>
</div>